import path from 'path'
import { isDev } from '@shared/utils/platform'

const Config = {
  NAME: isDev ? 'Highlight Dev' : 'Highlight', // DO NOT CHANGE THIS UNLESS YOU KNOW WHAT YOU ARE DOING
  APP_ID: 'tv.medal.highlight', // DO NOT CHANGE THIS UNLESS YOU KNOW WHAT YOU ARE DOING
}

export default Config
export const NAME = Config.NAME
export const APP_ID = Config.APP_ID

/** Absolute path under `%SystemRoot%\system32` (Windows). */
export const windowsSystem32 = (...segments: string[]): string =>
  path.join(process.env.SystemRoot || process.env.windir || 'C:\\Windows', 'system32', ...segments)

/**
 * Custom protocol scheme for app deep links — `highlight://` in prod,
 * `highlight-dev://` in dev. Use {@link appDeepLink} to build a URL from a path
 * rather than re-deriving the `-dev` suffix at each call site.
 */
export const DEEPLINK_PREFIX = isDev ? 'highlight-dev' : 'highlight'

/** Build an app deep-link URL, e.g. `appDeepLink('settings/meeting-notes')`. */
export const appDeepLink = (path: string): string => `${DEEPLINK_PREFIX}://${path.replace(/^\/+/, '')}`

/*
 * Telemetry v1 will always use supabase id as userId in amplitude.
 * Moving forward, v2 will properly set anonymous users to deviceId,
 * and logged in users to userId.
 */
export const TELEMETRY_VERSION = 2

/* DO NOT CHANGE */
export const uuidV1Key = 'uuid-1'
export const uuidV2Key = 'uuid-2'

// Hash of the shared build-channel access code that unlocks non-default channels
// in the desktop app. Cosmetic gate, not an access control — see
// hashChannelAccessCode in @highlight/common for why. Value must stay in sync with
// that helper's digest.
export const BUILDS_ACCESS_CODE_HASH = '647b03f166490186e4fabb0e44d5f607b131daf2'

export const AsrConstants = {
  MICROPHONE: 0,
  LOOPBACK: 1,
  BOTH: 2,
}

/**
 * Renderer invoke and native main-local emit for finalized ASR segments.
 * Electron capture includes the mic segment so main can retain PTT context.
 */
export const ASR_SEGMENT_END_EVENT = 'asr:segment-end'

/** Renderer invoke: the kind of mic the audio runtime just acquired for a meeting's audio session. */
export const AUDIO_RUNTIME_MIC_KIND_EVENT = 'audio-runtime:mic-kind'

/**
 * There are appended to the user agent for every request,
 * indicating to backend what the client is compatible with.
 */
enum CompatibilityFlags {
  Summary_GithubFlavorMarkdown = 'summary_gfm',
  Summary_Citations = 'summary_citations',
  Timeline_Summary = 'timeline_summary',
  Reminder_Sources = 'reminder_sources',
}
export const CLIENT_COMPATIBILITY_FLAGS = Object.values(CompatibilityFlags)
